import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  isAnySidebarOpen = signal(false);

  openSidebar(): void {
    this.isAnySidebarOpen.set(true);
  }

  closeSidebar(): void {
    this.isAnySidebarOpen.set(false);
  }
}
